













import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {
    "cprod-auto-renew-msg": () =>
      import("@/components/app/global/contractProducts/cProdAutoRenewMsg.vue")
  }
})
export default class CProdAutoRenewComp extends Vue {
  // Props
  @Prop({
    required: true,
    validator: tag =>
      ["u-aside", "u-section-box", "u-contextualise"].includes(tag)
  })
  public readonly tag!: string;
}
